var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 18.4004C17.57 18.4004 0 27.8878 0 40.0004C0 52.113 17.57 61.6004 40 61.6004C62.43 61.6004 80 52.113 80 40.0004C80 27.8878 62.43 18.4004 40 18.4004ZM35.8467 25.0465H40.2133L38.8267 31.6927H42.7267C45.2 31.6927 46.86 32.0383 47.8067 32.899C48.73 33.7497 49.01 35.1454 48.64 37.0462L46.9067 44.985H42.4667L44.0633 37.6443C44.2567 36.6374 44.18 35.9363 43.84 35.5674C43.5033 35.1985 42.76 35.0158 41.6467 35.0158H38.15L36.04 44.985H31.6667L35.8467 25.0465ZM16.6667 31.6927H25.5533C29.79 31.6927 32.3567 34.524 31.3533 38.7476C30.1867 43.6558 27.0667 44.985 21.32 44.985H18.5733L17.7033 49.9696H13.2867L16.6667 31.6927ZM51.6667 31.6927H60.5533C64.79 31.6927 67.3567 34.524 66.3533 38.7476C65.1867 43.6558 62.0633 44.985 56.32 44.985H53.5733L52.7033 49.9696H48.2867L51.6667 31.6927ZM20.45 35.0158L19.1933 41.6619H22.0433C24.51 41.6619 26.8033 41.3828 27.1867 37.7141C27.33 36.2952 26.7367 35.0158 23.8867 35.0158H20.45ZM55.45 35.0158L54.1933 41.6619H57.0433C59.51 41.6619 61.8033 41.3828 62.1867 37.7141C62.33 36.2952 61.74 35.0158 58.8867 35.0158H55.45Z",
    fill: "#4F5C94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/php.1fe6f8a203234e9784679ad6e0aa6d96.svg";
export { ForwardRef as ReactComponent };